import React from 'react'
import { Link } from 'react-router-dom'
import { PageHeader, Typography } from 'antd'
import { connect } from 'dva'
import classNames from 'classnames'
import GridContent from './GridContent'
import styles from './index.module.less'

const { Title } = Typography

const PageWrapper = ({
  children,
  contentWidth,
  wrapperClassName,
  curBreadcrumbsList,
  top,
  title,
  content,
  logo,
  extraContent,
  hiddenBreadcrumb = true,
  border = false,
  footer = null,
  extraMainStyle = {},
  fill = false,
  ...restProps
}) => {
  const style = border
    ? {
        border: '1px solid #e8e8e8',
        marginBottom: '16px',
        ...extraMainStyle,
      }
    : {
        marginBottom: '16px',
        ...extraMainStyle,
      }
  const breadcrumb = hiddenBreadcrumb
    ? null
    : {
        routes: curBreadcrumbsList,
        itemRender: (route) => {
          const { component, path, breadcrumbName } = route
          return !component && path !== '/' ? (
            <span>{breadcrumbName}</span>
          ) : (
            <Link to={path}>{breadcrumbName}</Link>
          )
        },
      }
  return (
    <div style={style} className={classNames(classNames, styles.main)}>
      {top}
      <PageHeader
        wide={contentWidth === 'Fixed'}
        title={
          <Title
            level={4}
            style={{
              marginBottom: 0,
            }}
          >
            {title}
          </Title>
        }
        key="pageheader"
        {...restProps}
        breadcrumb={breadcrumb}
        className={styles.pageHeader}
        linkElement={Link}
      >
        <div className={styles.detail}>
          {logo && <div className={styles.logo}>{logo}</div>}
          <div className={styles.main}>
            <div className={styles.row}>
              {content && <div className={styles.content}>{content}</div>}
              {extraContent && (
                <div className={styles.extraContent}>{extraContent}</div>
              )}
            </div>
          </div>
        </div>
      </PageHeader>
      {children ? (
        <div
          className={`${styles['children-content']} ${
            fill ? styles['is-fill'] : ''
          }`}
        >
          <GridContent>{children}</GridContent>
        </div>
      ) : null}
      {footer ? <div className={styles.footer}>{footer}</div> : null}
    </div>
  )
}

export default connect(({ setting, global }) => ({
  contentWidth: setting.contentWidth,
  curBreadcrumbsList: global.curBreadcrumbsList,
}))(PageWrapper)
